import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Badge,
  Accordion,
  // useAccordionButton,
  InputGroup,
} from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import "./DetalleOrden.css";
import TimeIntervalPicker from "./TimeIntervalPicker";
import HorizontalDatePicker from "../../HorizontalDatePicker";
import { onSnapshot } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPlus,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";
const DetallePedido = ({
  plati,
  anadidos,
  ingredientes,
  anadirPedido,
  handlebackPlatillos,
  detalleOrden,
  selectCostosItem,
}) => {
  const [nota, setNota] = useState("");
  const [ingredientesMostrar, setIngredientesMostrar] = useState([]);
  const [anadid, setAnadid] = useState(plati?.anadidos ? plati.anadidos : {});
  const [platillo, setPlatillo] = useState(plati);
  const [qty, setQty] = useState(1);
  // const [optionactive, setOptionActive] = useState("Horario");
  const fecha = new Date();
  const fechaActual = fecha.toISOString().split("T")[0];
  fecha.setDate(fecha.getDate() + 7);
  const fechaFinalForm = fecha.toISOString().split("T")[0];
  const dias = [
    "domingo",
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
  ];
  const numeroDia = new Date().getDay();
  const [dispo, setDispo] = useState();
  const [reser, setReser] = useState();
  const nombreDia = dias[numeroDia === 7 ? 0 : numeroDia];
  const [restante, setRestante] = useState(0);
  const [listaingredientes, setListaIngredientes] = useState({});
  const [selectedDate, setSelectedDate] = useState(fechaActual);
  const [selectedDay, setSelectedDay] = useState(nombreDia);
  const [selectedTime, setSelectedTime] = useState("");

  const handleNota = (nota) => setNota(nota);
  const handleQty = (qty) => {
    let acum = 0;
    if (dispo && dispo[selectedDate] && dispo[selectedDate][selectedTime]) {
      acum = dispo[selectedDate][selectedTime];
    }
    if (reser && reser[selectedDate] && reser[selectedDate][selectedTime]) {
      acum += reser[selectedDate][selectedTime];
    }
    if (detalleOrden) {
      const itemtime = detalleOrden?.filter((ite) => {
        return (
          ite.selectedTime === selectedTime &&
          ite.id === platillo.id &&
          ite.selectedDate === selectedDate
        );
      });
      const cant = itemtime.reduce((acom, ita) => acom + ita.cantidad, 0);
      acum += cant;
    }
    if (
      ((platillo.limite && parseInt(restante) >= parseInt(qty)) ||
        !platillo.limite) &&
      (!(
        platillo.modo === "PREVENTA" || platillo.modo === "RECOGER CON HORARIO"
      ) ||
        parseInt(qty) <= parseInt(platillo?.maxOrd) - acum)
    ) {
      let tcantidad = qty;
      setQty(tcantidad);
    }
  };
  const handleAnadidos = (e, index) => {
    let tempan = { ...anadid };
    let newplat = {
      cantidad: e.target.value === "" ? "0" : e.target.value,
      precio: anadidos[index].free ? 0 : anadidos[index].precio,
      name: anadidos[index].name,
    };
    tempan[anadidos[index].id] = newplat;
    setAnadid(tempan);
  };

  const checkChange = (id, name, cantidad, categoria, costo) => {
    let copia = { ...listaingredientes };
    if (copia.hasOwnProperty(id)) {
      delete copia[id];
    } else {
      let suma = 0;
      Object.keys(copia)
        .filter((e) => copia[e].categoria === categoria)
        .forEach((key) => {
          suma += parseInt(copia[key].cantidad);
        });
      if (suma === parseInt(cantidad) && !copia.hasOwnProperty(id)) {
        alert("Ya cuentas con el maximo de ingredientes para la categoria");
        return;
      } else {
        let valores = copia;
        valores[id] = {
          name: name,
          categoria: categoria,
          cantidad: 1,
          costo: costo,
        };
      }
    }
    setListaIngredientes(copia);
  };

  const totaladicionales =
    Object.keys(anadid).reduce((acc, item) => {
      return (
        acc +
        parseFloat(anadid[item].cantidad) *
          parseFloat(anadid[item].precio ? anadid[item].precio : 0)
      );
    }, 0) +
    Object.keys(listaingredientes).reduce((acc, item) => {
      return (
        acc +
        parseFloat(listaingredientes[item].cantidad) *
          parseFloat(
            listaingredientes[item].costo ? listaingredientes[item].costo : 0,
          )
      );
    }, 0);

  const handleIngredientes = (id, name, cantidad, categoria) => {
    let e = document.getElementById(id);
    let valor = e.value;
    let copia = { ...listaingredientes };
    let suma = 0;
    Object.keys(copia)
      .filter((e) => copia[e].categoria === categoria && e !== id)
      .forEach((key) => {
        suma += parseInt(copia[key].cantidad);
      });
    let select = ingredientes.filter((e) => e.id === id);
    if (parseInt(e.value) > select[0].cantidad) {
      valor = select[0].cantidad;
      copia[id].cantidad = parseInt(valor);
      alert("Ya cuentas con la cantidad maxima de " + name);
    }
    if (
      (e.value !== valor && suma + parseInt(valor) > parseInt(cantidad)) ||
      (e.value === valor && suma + parseInt(e.value) > parseInt(cantidad))
    ) {
      alert("Ya cuentas con la cantidad maxima para la categoria");
      valor = parseInt(cantidad) - suma;
    }
    copia[id].cantidad = parseInt(valor);
    console.log(copia);
    setListaIngredientes(copia);
  };

  const handleAgregar = () => {
    if (qty > restante) {
      alert("Producto agotado.");
    }
    if (!selectCostosItem) {
      alert("Seleccione una presentacion del platillo.");
      return;
    }
    if (!qty || qty <= 0) {
      alert("Seleccione una cantidad valida.");
      return;
    }
    let flag = 0;
    let totalAnadidos = 0.0;
    if (
      platillo.categoriasPers &&
      platillo.categoriasPers.length > 0 &&
      platillo.personalizable
    ) {
      platillo.categoriasPers.forEach((val) => {
        let suma = 0;
        Object.keys(listaingredientes)
          .filter((e) => listaingredientes[e].categoria === val.nombre)
          .forEach((key) => {
            suma += parseInt(listaingredientes[key].cantidad);
            if (val.precios && Object.keys(val.precios).includes(key)) {
              totalAnadidos +=
                parseFloat(val.precios[key]) *
                parseInt(listaingredientes[key].cantidad);
              listaingredientes[key].costo = parseFloat(val.precios[key]);
            } else {
              listaingredientes[key].costo = 0;
            }
          });
        if (flag === 0 && suma < parseInt(val.ingredientes)) {
          alert("Selecciona la cantidad indicada para " + val.nombre + ".");
          flag++;
        }
      });
    }
    if (flag !== 0) {
      return;
    }

    if (anadid) {
      Object.keys(anadid).forEach((key) => {
        totalAnadidos +=
          parseFloat(anadid[key].cantidad) * parseFloat(anadid[key].precio);
      });
    }

    const updatedPlatillo = {
      cantidad: parseInt(qty),
      costo: selectCostosItem.costo,
      description: platillo.description,
      id: platillo.id,
      idv4: uuidv4(),
      img: platillo.img,
      name: platillo.name,
      ncosto: selectCostosItem.ncosto,
      note: nota,
      anadidos: anadid,
      ingredientes: listaingredientes,
      npuntos: selectCostosItem.puntos,
      status: "PENDIENTE",
      totalAnadidos: totalAnadidos,
      total: selectCostosItem.costo * parseInt(qty),
      puntos: selectCostosItem.puntos * parseInt(qty),
    };
    if (platillo?.modo === "RECOGER CON HORARIO" && selectedTime !== "") {
      updatedPlatillo.recoger = new Date(`${selectedDate}T${selectedTime}`);
      updatedPlatillo.recoger.setMinutes(
        updatedPlatillo.recoger.getMinutes() - parseInt(platillo?.estimado),
      );
      updatedPlatillo.selectedTime = selectedTime;
      updatedPlatillo.selectedDate = selectedDate;
    } else if (platillo?.modo === "RECOGER CON HORARIO") {
      alert("Seleccione una hora para recoger su pedido");
      return;
    }
    if (platillo?.modo === "PREVENTA" && selectedTime !== "") {
      updatedPlatillo.recoger = new Date(`${selectedDate}T${selectedTime}`);
      updatedPlatillo.recoger.setMinutes(
        updatedPlatillo.recoger.getMinutes() - parseInt(platillo?.estimado),
      );
      updatedPlatillo.selectedTime = selectedTime;
      updatedPlatillo.selectedDate = selectedDate;
    } else if (platillo?.modo === "PREVENTA") {
      alert("Seleccione dia y hora para recoger su pedido");
      return;
    }
    updatedPlatillo.selectedDate = selectedDate;
    if (selectCostosItem.puntos) {
      updatedPlatillo.npuntos = selectCostosItem.puntos;
      updatedPlatillo.puntos = selectCostosItem.puntos * parseInt(qty);
    } else {
      updatedPlatillo.npuntos = 0;
      updatedPlatillo.puntos = 0;
    }
    handlebackPlatillos();
    anadirPedido(updatedPlatillo);
  };

  // function CustomToggle({ text, eventKey }) {
  //   const decoratedOnClick = useAccordionButton(eventKey, () =>
  //     setOptionActive(eventKey),
  //   );

  //   return (
  //     <Button
  //       variant="ds"
  //       id={eventKey === optionactive ? "options-active" : "options"}
  //       className="newbutton-style nonfilledtext-color"
  //       onClick={decoratedOnClick}
  //     >
  //       <i
  //         className="bx bx-list-ul"
  //         style={{ fontSize: "25px", marginRight: 10 }}
  //       ></i>
  //       {text}
  //     </Button>
  //   );
  // }

  useEffect(() => {
    if (platillo) {
      platillo.anadidos = {};
      platillo.listaingredientes = {};
      if (platillo.especificos && platillo.ingesp) {
        setIngredientesMostrar(
          ingredientes.filter((e) => platillo.ingesp.includes(e.id)),
        );
      } else {
        setIngredientesMostrar(ingredientes);
      }
    }
  }, [ingredientes, platillo]);

  useEffect(() => {
    if (plati) {
      onSnapshot(plati.refDoc, (doc) => {
        let datos = doc.data();
        datos.id = doc.id;
        datos.refDoc = doc.ref;
        setPlatillo(datos);
        setDispo(datos.fechas);
        setReser(datos.reservados);
      });
    }
  }, [plati]);

  useEffect(() => {
    let restante = platillo?.piezas;
    if (dispo && dispo[selectedDate]) {
      let acum = 0;
      Object.keys(dispo[selectedDate]).forEach((ittem) => {
        acum += dispo[selectedDate][ittem];
      });
      restante = restante - acum;
    }
    if (reser && reser[selectedDate]) {
      let acum = 0;
      Object.keys(reser[selectedDate]).forEach((ittem) => {
        acum += reser[selectedDate][ittem];
      });
      restante = restante - acum;
    }
    setRestante(restante);
    if (qty > restante) {
      setQty(restante);
    }
    if (qty === 0 && restante > 1) {
      setQty(1);
    }
  }, [selectedDate, dispo, reser, platillo, qty]);

  return (
    <Accordion defaultActiveKey={"Horario"}>
      <Row>
        {/* <Row
          id="rowbsnone"
          style={{
            overflow: "auto",
            flexWrap: "unset",
            overflowY: "hidden",
          }}
        >
          {platillo &&
            (platillo.modo === "PREVENTA" ||
              platillo.modo === "RECOGER CON HORARIO") && (
              <CustomToggle text={"Horario"} eventKey={"Horario"} />
            )}
          {anadidos && anadidos.length > 0 && (
            <CustomToggle text={"Añadidos"} eventKey={"Añadidos"} />
          )}
          {platillo?.personalizable &&
            platillo?.categoriasPers &&
            platillo?.categoriasPers.map((item, index) => {
              return (
                <CustomToggle
                  text={item.nombre + " (" + item.ingredientes + ")"}
                  eventKey={"pers" + index}
                ></CustomToggle>
              );
            })}
        </Row> */}
        {/* <Accordion.Collapse eventKey="Horario"> */}
        <>
          {platillo &&
            (platillo.modo === "PREVENTA" ||
              platillo.modo === "RECOGER CON HORARIO") && (
              <h2 style={{ fontSize: 16, fontWeight: 600 }}>
                Horarios para recoger:
              </h2>
            )}
          {platillo && platillo.modo === "PREVENTA" && (
            <HorizontalDatePicker
              startDate={fechaActual}
              endDate={fechaFinalForm}
              allowedDays={[
                platillo?.lunes?.active && 1,
                platillo?.martes?.active && 2,
                platillo?.miercoles?.active && 3,
                platillo?.jueves?.active && 4,
                platillo?.viernes?.active && 5,
                platillo?.sabado?.active && 6,
                platillo?.domingo?.active && 0,
              ]}
              onSelect={(date) => {
                setSelectedDate(date);
                let dare = new Date(date).getDay() + 1;
                if (dare === 7) {
                  dare = 0;
                }
                setSelectedDay(dias[dare]);
                setSelectedTime("");
              }}
            />
          )}
          {platillo?.limite && restante <= 0 ? (
            <Badge
              style={{
                color: "white",
                marginHorizontal: "auto",
                fontSize: 16,
                fontWeight: "800",
                height: 50,
                paddingHorizontal: 15,
                marginTop: 10,
                backgroundColor: "red",
              }}
            >
              AGOTADO HOY
            </Badge>
          ) : (
            <>
              {platillo &&
              (platillo.modo === "PREVENTA" ||
                platillo.modo === "RECOGER CON HORARIO") &&
              ((platillo[selectedDay] && platillo[selectedDay].active) ||
                (platillo[nombreDia] && platillo[nombreDia].active)) ? (
                <TimeIntervalPicker
                  startTime={
                    platillo?.modo === "RECOGER CON HORARIO"
                      ? platillo[nombreDia].inicio
                      : platillo[selectedDay].inicio
                  }
                  endTime={
                    platillo?.modo === "RECOGER CON HORARIO"
                      ? platillo[nombreDia].fin
                      : platillo[selectedDay].fin
                  }
                  interval={parseInt(platillo?.intOrd)}
                  capacity={parseInt(platillo?.maxOrd)}
                  estimado={parseInt(platillo?.estimado)}
                  disponibilidad={dispo ? dispo[selectedDate] : undefined}
                  seleccionados={detalleOrden?.filter((ite) => {
                    return (
                      ite.id === platillo.id &&
                      ite.selectedDate === selectedDate
                    );
                  })}
                  reservados={reser ? reser[selectedDate] : undefined}
                  onSelect={(time) => {
                    setSelectedTime(time.timeJS);
                  }}
                  actual={selectedDate === fechaActual}
                />
              ) : (
                platillo?.modo === "RECOGER CON HORARIO" && (
                  <>
                    <h1 style={{ fontSize: 16, fontWeight: 600, marginTop: 8 }}>
                      Disponible hasta el{" "}
                      {dias.find((value) => {
                        return (
                          platillo[value]?.active &&
                          dias.indexOf(value) > dias.indexOf(nombreDia)
                        );
                      }) ||
                        dias.find((value) => {
                          return (
                            platillo[value]?.active &&
                            dias.indexOf(value) < dias.indexOf(nombreDia)
                          );
                        })}
                    </h1>
                    <TimeIntervalPicker
                      startTime={
                        platillo[
                          dias.find((value) => {
                            return (
                              platillo[value]?.active &&
                              dias.indexOf(value) > dias.indexOf(nombreDia)
                            );
                          }) ||
                            dias.find((value) => {
                              return (
                                platillo[value]?.active &&
                                dias.indexOf(value) < dias.indexOf(nombreDia)
                              );
                            })
                        ]?.inicio
                      }
                      endTime={
                        platillo[
                          dias.find((value) => {
                            return (
                              platillo[value]?.active &&
                              dias.indexOf(value) > dias.indexOf(nombreDia)
                            );
                          }) ||
                            dias.find((value) => {
                              return (
                                platillo[value]?.active &&
                                dias.indexOf(value) < dias.indexOf(nombreDia)
                              );
                            })
                        ]?.fin
                      }
                      interval={60}
                      capacity={0}
                      estimado={parseInt(platillo?.estimado)}
                      actual={false}
                    />
                  </>
                )
              )}
            </>
          )}
        </>
        {/* </Accordion.Collapse> */}
        {platillo?.personalizable &&
          platillo?.categoriasPers &&
          platillo?.categoriasPers.map((item, index) => {
            return (
              // <Accordion.Collapse eventKey={"pers" + index}>
              <Row id="Ingredientes">
                <h6
                  style={{
                    color: index % 2 !== 0 ? "blue" : "red",
                    textAlign: "left",
                    marginTop: 5,
                  }}
                >
                  <strong style={{ fontSize: 22 }}>
                    {index + 1}. {item.nombre}
                  </strong>{" "}
                  {" (Selecciona hasta " + item.ingredientes + ")"}
                </h6>
                <div id="ScrollAna">
                  <Row style={{ paddingTop: 3, alignItems: "center" }}>
                    {ingredientes
                      .filter((e) => item.lista.includes(e.id))
                      .map((val, index) => (
                        <Col md={6}>
                          <label
                            className="lblqrdinamico"
                            style={{
                              paddingTop: "5px",
                              paddingLeft: "20px",
                            }}
                          >
                            {val.name}
                            {item.precios &&
                            Object.keys(item.precios).includes(val.id) ? (
                              "($" +
                              parseFloat(item.precios[val.id]).toFixed(2) +
                              ")"
                            ) : (
                              <></>
                            )}
                          </label>
                          <Row
                            style={{
                              alignSelf: "center",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              style={{
                                border: "1px solid",
                                paddingTop: "0px",
                              }}
                              className="form-check-input stl"
                              type="checkbox"
                              checked={listaingredientes?.hasOwnProperty(
                                val.id,
                              )}
                              onChange={() =>
                                checkChange(
                                  val.id,
                                  val.name,
                                  item.ingredientes,
                                  item.nombre,
                                  Object.keys(
                                    item.precios ? item.precios : [],
                                  ).includes(val.id)
                                    ? item.precios[val.id]
                                    : 0,
                                )
                              }
                              id={"Ing" + index}
                            />
                            <Form.Control
                              type="number"
                              style={{ width: "70%", marginLeft: 10 }}
                              placeholder="Cantidad"
                              disabled={
                                !listaingredientes?.hasOwnProperty(val.id)
                              }
                              name={val.name}
                              id={val.id}
                              value={
                                listaingredientes?.hasOwnProperty(val.id)
                                  ? listaingredientes[val.id]?.cantidad
                                    ? listaingredientes[val.id].cantidad
                                    : 1
                                  : 0
                              }
                              min={1}
                              onChange={() =>
                                handleIngredientes(
                                  val.id,
                                  val.name,
                                  item.ingredientes,
                                  item.nombre,
                                )
                              }
                            />
                          </Row>
                        </Col>
                      ))}
                  </Row>
                </div>
              </Row>
              // </Accordion.Collapse>
            );
          })}
        {/* <Accordion.Collapse eventKey="Añadidos"> */}
        <Row id="Anadidos">
          <h6
            style={{
              color:
                platillo?.personalizable &&
                platillo?.categoriasPers &&
                platillo?.categoriasPers.length % 2 !== 0
                  ? "blue"
                  : "red",
              textAlign: "left",
              marginTop: 5,
            }}
          >
            <strong style={{ fontSize: 22 }}>
              {platillo?.personalizable && platillo?.categoriasPers
                ? platillo?.categoriasPers.length + 1
                : 1}
              . Añadidos
            </strong>
          </h6>
          <div id="ScrollAna">
            <Row style={{ paddingTop: 3 }}>
              {anadidos.map((val, index) => (
                <Col
                  md={6}
                  style={{
                    alignContent: "center",
                    justifyContent: "center",
                    textAlign: "left",
                  }}
                >
                  {index}.
                  <label
                    className="lblqrdinamico"
                    style={{
                      paddingTop: "5px",
                      paddingLeft: "5px",
                    }}
                  >
                    {val.name}(
                    {val.free || parseFloat(val.precio) <= 0
                      ? "Gratis"
                      : "$" + val.precio}
                    )
                  </label>
                  <Row
                    style={{ alignSelf: "center", justifyContent: "center" }}
                  >
                    <Form.Control
                      type="number"
                      placeholder="Cantidad"
                      name={val.name}
                      value={
                        anadid && anadid[anadidos[index].id]
                          ? anadid[anadidos[index].id].cantidad
                          : 0
                      }
                      min={0}
                      style={{ width: "70%" }}
                      onChange={(e) => handleAnadidos(e, index)}
                    />
                  </Row>
                </Col>
              ))}
            </Row>
          </div>
        </Row>
        {/* </Accordion.Collapse> */}
        <Col xs={8} sm={8} md={8} lg={8}>
          Nota
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Añade comentarios a tu pedido"
            onChange={(e) => handleNota(e.target.value)}
          />
        </Col>
        <Col md={4}>
          Cantidad
          <InputGroup className="mb-2" style={{ justifyContent: "center" }}>
            <Button
              variant="outline-dark"
              onClick={() => {
                if (qty > 1) handleQty(qty - 1);
              }}
            >
              <FontAwesomeIcon icon={faMinus} style={{ fontSize: 13 }} />
            </Button>
            <InputGroup.Text style={{ fontSize: 13 }}>{qty}</InputGroup.Text>
            <Button variant="outline-dark" onClick={() => handleQty(qty + 1)}>
              <FontAwesomeIcon icon={faPlus} style={{ fontSize: 13 }} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row style={{ justifyContent: "center", marginTop: 5 }}>
        <Col md={6}>
          <small className="text-muted d-block">Total:</small>
          <h4 className="text-success fw-bold">
            $
            {(
              (parseFloat(selectCostosItem.costo) + totaladicionales) *
              qty
            ).toFixed(2)}
          </h4>
        </Col>
        <Col md={6}>
          <Button
            variant="success"
            id="agregar"
            onClick={handleAgregar}
            style={{ width: "100%" }}
          >
            <FontAwesomeIcon icon={faShoppingCart} />
            Agregar
          </Button>
        </Col>
      </Row>
    </Accordion>
  );
};

export default DetallePedido;
